import React, { useState } from 'react'

// components
import {
  CCol,
  CRow,
  CFormLabel,
  CFormInput,
  CFormCheck,
  CFormText,
  CAccordion,
  CAccordionHeader,
  CAccordionBody,
  CAccordionItem,
  CButton,
  CInputGroup,
  CInputGroupText,
  CImage
} from '@coreui/react-pro'
import FormProductVariant from '../general-input-form/FormProductVariant';

// icons
import TrashIcon from '../../../assets/icons/TrashIcon.png'

// styling
import { styleButtonVars3 } from 'src/components/custom-styles/buttonStyles';
import { styleInputVariantInfo1 } from 'src/components/custom-styles/inputStyles';

// helpers
import { capitalizeEachWord } from 'src/helpers/text-format';

const AppSecondForm = ({
  editPage,
  values,
  errors,
  isProductVariantEmpty,
  openFormProductCombination,
  setOpenFormProductCombination,
  setInputVariant,
  setShowConfirmDelete,
  inputVariant,
  handleInputVariantType,
  handleRemoveInputVariantType,
  handleAddVariantOptions,
  handleRemoveVariantOptions,
  handleTextVariantOptions,
  handlePriceVariantOptions,
  handleImageVariantOptions,
  handleRemoveImageVariantOptions,
  setOpenFilePreview,
  handleFileInput,
  handleRemoveImage
}) => {

  return (
    <>
      <CRow className="mb-3">
        <CCol lg='12'>
          <CFormLabel>
            Product Variant Type
          </CFormLabel>
          <CInputGroup>
            <CFormInput
              placeholder='Fill in product variant type...'
              value={inputVariant}
              onChange={({ target: { value } }) => setInputVariant(value)}
              onKeyDown={(e) => handleInputVariantType(e)}
            />
            <CInputGroupText>
              <CImage fluid src={TrashIcon} />
            </CInputGroupText>
          </CInputGroup>
          <p className='mt-2' style={styleInputVariantInfo1}>
            Click <b>'Enter'</b> to Add or <b>'Esc'</b> to Cancel
          </p>
        </CCol>
        {isProductVariantEmpty && (
          <CFormText className='error-text-field'>
            Please fill out all of the fields for option name and option price.
          </CFormText>
        )}
      </CRow>
      <CRow className="mb-4">
        <CCol lg='12'>
          {values.product_variants.length > 0 && (
            <CAccordion>
              {values.product_variants.map((variant, index) => {
                return (
                  <CAccordionItem itemKey={index} key={index} >
                    <CAccordionHeader>
                      <b>{variant.name}</b>
                      <CButton
                        className='ms-3'
                        style={styleButtonVars3}
                        onClick={() => {
                          variant.variant_id ?
                            setShowConfirmDelete({ show: true, item: variant, type: 'product-variant-type' })
                            : handleRemoveInputVariantType(variant)
                        }}
                      >
                        <CImage
                          fluid
                          src={TrashIcon}
                          className='me-2 mb-1'
                        />
                        Remove
                      </CButton>
                    </CAccordionHeader>
                    <CAccordionBody>
                      <FormProductVariant
                        formProduct
                        editPage={editPage}
                        variantType={variant}
                        variantIndex={index}
                        values={values}
                        errors={errors}
                        inputLabel='Product Variant Options'
                        placeholder='Fill in product variant option...'
                        setOpenFilePreview={setOpenFilePreview}
                        setShowConfirmDelete={setShowConfirmDelete}
                        handleAddVariantOptions={handleAddVariantOptions}
                        handleRemoveVariantOptions={handleRemoveVariantOptions}
                        handleTextVariantOptions={handleTextVariantOptions}
                        handlePriceVariantOptions={handlePriceVariantOptions}
                        handleImageVariantOptions={handleImageVariantOptions}
                        handleRemoveImageVariantOptions={handleRemoveImageVariantOptions}
                      />
                    </CAccordionBody>
                  </CAccordionItem>
                )
              })}
            </CAccordion>
          )}
        </CCol>
      </CRow>
      {values.product_variants.length > 0 && (
        <CRow className="mb-4">
          <CCol lg='6'>
            <CFormCheck
              label="Add product combination"
              onClick={() => setOpenFormProductCombination((prev) => !prev)}
              checked={openFormProductCombination}
            />
          </CCol>
          <CCol lg='6'>
            {null}
          </CCol>
        </CRow>
      )}
    </>
  )
}

export default AppSecondForm
